@if ({
  loading: loading$ | async,
  pageLimitedItems: pageLimitedItems$ | async,
  page: page$ | async,
  postsShowLimit: postsShowLimit$ | async,
}; as extracted) {
<div class="blog-root">

  <!-- Header section -->
  <div class="header blog-root__header">
    <div class="image-wrap header__image-wrap">
      <div class="image header__image"></div>
    </div>

    <div class="menu-wrap header__menu-wrap">
      <app-general-header theme="light"></app-general-header>
    </div>

    <div class="caption-wrap header__caption-wrap">
      <h2 class="menu-caption header__menu-caption">The BrainKey Blog</h2>
    </div>
  </div>
  <!-- Header section -->


  <div class="content-wrap b-container">
    <div class="blog-container">

      <!-- Recent posts section -->
      <h2 class="recent-posts-title blog-root__recent-posts-title b-flow__text">Recent Posts</h2>

      <div class="recent-posts blog-root__recent-posts">
        @if (extracted.loading) {
          <div class="post recent-posts__post">
            <div class="spinner-wrap post__spinner-wrap">
              <mat-spinner></mat-spinner>
            </div>
          </div>
          <div class="post recent-posts__post">
            <div class="spinner-wrap post__spinner-wrap">
              <mat-spinner></mat-spinner>
            </div>
          </div>
          <div class="post recent-posts__post">
            <div class="spinner-wrap post__spinner-wrap">
              <mat-spinner></mat-spinner>
            </div>
          </div>
        } @else {
            @for (item of extracted.pageLimitedItems.items; track item?.id) {
              <div class="post recent-posts__post" [@fadeIn]>
                <div class="thumbnail-wrap post__thumbnail-wrap">
                  <a routerLink="{{item.url}}">
                    @if (item.thumbnail) {
                      <img class="thumbnail post__thumbnail" src="{{item.thumbnail['url']}}" alt="post_thumbnail">
                    }
                  </a>
                </div>
                <div class="date post__date b-flow__text">{{item.date_obj | date:"longDate"}}</div>
                <div class="text-content post__text-content">
                  <a routerLink="{{item.url}}">
                    <div class="caption post__caption b-flow__text">{{item.title}}</div>
                  </a>
                  <div class="short-content post__short-content b-flow__text" [innerHtml]="item['intro_html']"></div>
                </div>
                <div class="read-more post__read-more b-flow__next-button" routerLink="{{item.url}}">
                  <span>Read More</span>
                  <img src="/assets/images/dashboard/flows/arrow-right--blue.svg" alt="">
                </div>
              </div>
            }
            @if (extracted.page?.items?.length > extracted.postsShowLimit) {
              <button
                class="b-button b-button--light show-more recent-posts__show-more"
                (click)="showMorePosts()"
              >Show more</button>
            }
        }
      </div>
      <!-- Recent posts section -->


      <!-- Subscribe section -->
      <div class="subscribe blog-root__subscribe">
        <div class="newsletter subscribe__newsletter">
          <rt-loading [until]="extracted.loading === false">
            <app-blog-newsletter></app-blog-newsletter>
          </rt-loading>
        </div>

        <div class="follow-us subscribe__follow-us">
          <h4 class="header follow-us__header">Follow Us</h4>
          <div class="social-items-wrap follow-us__social-items-wrap">
            <div class="social-item follow-us__social-item">
              <a class="link social-item__link" href="https://www.instagram.com/brainkeyai/" target="_blank">
                <img src="/assets/images/contact-us/instagram-icon.svg" alt="instagram">
              </a>
            </div>
            <div class="social-item follow-us__social-item">
              <a class="link social-item__link" href="https://www.linkedin.com/company/brainkeyai/" target="_blank">
                <img src="/assets/images/contact-us/linkedin-icon.svg" alt="linkedin">
              </a>
            </div>
            <div class="social-item follow-us__social-item">
              <a class="link social-item__link" href="https://www.facebook.com/BrainKeyAI" target="_blank">
                <img src="/assets/images/contact-us/facebook-icon.svg" alt="facebook">
              </a>
            </div>
            <div class="social-item follow-us__social-item">
              <a class="link social-item__link" href="https://x.com/BrainkeyAI" target="_blank">
                <img src="/assets/images/contact-us/x-icon.svg" alt="x">
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Subscribe section -->
    </div>
  </div>


  <!-- Explore brain section -->
  <app-explore-your-brain></app-explore-your-brain>
  <!-- Explore brain section -->

  <app-footer></app-footer>

</div>
}
